/**
 * @fileoverview The one Toshokan Pass price list for the web app (COO DECISION 012/019).
 * The amount actually charged lives in the Stripe Price objects (STRIPE_PRICE_PREMIUM_*);
 * keep these in step with Stripe.
 */
const MONTHLY = 3.99;
const ANNUAL = 29.99;

export const PASS_PRICE_MONTHLY = `€${MONTHLY}`;
export const PASS_PRICE_ANNUAL = `€${ANNUAL}`;
export const PASS_ANNUAL_SAVING = `${Math.round((1 - ANNUAL / (MONTHLY * 12)) * 100)}%`;
